import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

import type { ICardOffer } from './models';
import { isEven, isLastLine } from './helpers';

export const DEFAULT_CATEGORY = 'popular';

export const getCardStylerMobile = (): IStyler => ({
    marginBottom: 12,
});

export const getCardStylerDesktop = (index: number, filteredOffers: ICardOffer[]): IStyler => ({
    marginRight: isEven(index) ? 24 : 0,
    marginBottom: isLastLine(index, filteredOffers) ? 0 : 24,
});

export const INITIAL_TARGET = {
    targetId: null,
    offerTitle: '',
    productId: null,
    updatedAt: null,
    creditAmount: 0,
    creditTerm: 0,
};

export const pilPreparedKey = 'pilPrepared';

export const APPLY_PREPARED_OFFER_EVENT = 'apply_prepared_offer';
